import { Box, FormHelperText } from '@mui/material';

import { Text } from 'common';

export function GetInsurancesBlockContent() {
  return (
    <Box>
      <Text>No configuration required</Text>
      <FormHelperText>
        Extract patient insurances from Notable database corresponding to Start blocks output
        entity.
      </FormHelperText>
    </Box>
  );
}
